<template>
  <div class="hm-taxsaas-apply" :class="{'hm-taxsaas-apply_h5': isH5}">
    <div class="title">{{title}}</div>
    <Apply :isShowLabelText="!isH5" />
  </div>
</template>

<script>
import Apply from '@/components/hm-apply'

export default {
  name: 'hmTaxsaasApply',
  props: {
    isH5: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: { Apply },
  data () {
    return {}
  }
}
</script>

<style lang="less">
.hm-taxsaas-apply {
  width: 400PX;
  height: 396PX;
  background: #FFFFFF;
  box-shadow: 0 2PX 8PX 0 rgba(216,221,230,1);
  border-radius: 8PX;
  padding: 40PX 36PX;
  .title {
    font-weight: 500;
    font-size: 24PX;
    color: #292F3A;
    margin-bottom: 29PX;
  }
  &.hm-taxsaas-apply_h5 {
    width: 100%;
    height: 34.5rem;
    padding: 0;
    border-radius: 0.8rem;
    box-shadow: 0 0.4rem 0.8rem 0 rgba(206,214,230,0.3);
    .title {
      font-size: 1.6rem;
      color: #292F3A;
      letter-spacing: 0;
      line-height: 2.4rem;
      font-weight: 500;
      padding: 2rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hm-taxsaas-apply/index.vue